webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(7)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(11),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Hello__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Hello__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Hello: __WEBPACK_IMPORTED_MODULE_0__components_Hello___default.a
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      email: 'vinayak.kulkarni@live.com'
    };
  }
});

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(6)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(10),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide",
    attrs: {
      "id": "s1"
    }
  }, [_c('div', {
    staticClass: "slide",
    attrs: {
      "id": "s2"
    }
  }, [_c('div', {
    staticClass: "slide",
    attrs: {
      "id": "s3"
    }
  }, [_c('div', {
    staticClass: "slide",
    attrs: {
      "id": "s4"
    }
  }, [_c('div', {
    staticClass: "slide",
    attrs: {
      "id": "s5"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "p1"
    }
  }, [_c('section', {
    staticClass: "icon"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Web Developer  "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:vinayak.kulkarni@live.com"
    }
  }, [_vm._v(_vm._s(_vm.email))])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    attrs: {
      "id": "menu"
    }
  }, [_c('a', {
    attrs: {
      "href": "#s1"
    }
  }, [_c('li', {
    staticClass: "icon fa fa-home",
    attrs: {
      "id": "home"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#s2"
    }
  }, [_c('li', {
    staticClass: "icon fa fa-user",
    attrs: {
      "id": "user"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#s3"
    }
  }, [_c('li', {
    staticClass: "icon fa fa-code",
    attrs: {
      "id": "skill"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#s5"
    }
  }, [_c('li', {
    staticClass: "icon fa fa-gamepad",
    attrs: {
      "id": "game"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "homeTitle"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "50%"
    },
    attrs: {
      "src": __webpack_require__(8),
      "alt": "Vinayak Logo"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "c-article__title"
  }, [_vm._v("Vinayak Kulkarni")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "id": "p2"
    }
  }, [_c('section', {
    staticClass: "icon2 fa fa-user"
  }, [_c('span', {
    staticClass: "aboutTitle"
  }, [_vm._v("About Me")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', [_c('i', {
    staticClass: "subicon fa fa-graduation-cap"
  }), _c('br'), _c('strong', [_vm._v("University of Pune")]), _c('br'), _vm._v("Masters in Computer Science")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "subicon fa fa-soccer-ball-o"
  }), _c('br'), _c('strong', [_vm._v("Arsenal")]), _c('br'), _vm._v("Come on you Gooners!")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "subicon fa fa-github"
  }), _c('br'), _c('strong', [_vm._v("GitHub")]), _c('br'), _c('a', {
    attrs: {
      "href": "https://github.com/vinayakkulkarni"
    }
  }, [_vm._v("Checkout my GitHub Profile")])]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "subicon fa fa-map-marker"
  }), _c('br'), _c('strong', [_vm._v("Bangalore, KA")]), _c('br'), _vm._v("India")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "id": "p3"
    }
  }, [_c('section', {
    staticClass: "icon2 fa fa-code"
  }, [_c('span', {
    staticClass: "aboutTitle"
  }, [_vm._v("Skills")]), _vm._v(" "), _c('div', {
    staticClass: "skillblock"
  }, [_c('span', [_c('i', {
    staticClass: "subicon fa fa-globe"
  }), _c('br'), _c('strong', [_vm._v("Web Development")]), _c('br'), _vm._v("HTML, CSS\n                  "), _c('br'), _vm._v("VueJS 💕\n                  "), _c('br'), _vm._v("Semantic-UI, jQuery, Vanilla JS\n                  "), _c('br'), _vm._v("Laravel\n                  "), _c('br'), _vm._v("AngularJS, ionic\n                ")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "subicon fa fa-laptop"
  }), _c('br'), _c('strong', [_vm._v("Software Development")]), _c('br'), _vm._v("JSON\n                ")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "subicon fa fa-database"
  }), _c('br'), _c('strong', [_vm._v("Database Management")]), _vm._v(" "), _c('br'), _vm._v("MySQL, Oracle\n                  "), _c('br'), _vm._v("MongoDB, Firebase\n                ")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "subicon fa fa-folder"
  }), _c('br'), _c('strong', [_vm._v("Miscellaneous")]), _c('br'), _vm._v("NPM\n                  "), _c('br'), _vm._v("Cordova, AngularJS\n                  "), _c('br'), _vm._v("Ionic, Bootstrap\n                  "), _c('br'), _vm._v("Materialize, Git\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "id": "p5"
    }
  }, [_c('section', {
    staticClass: "icon2 fa fa-gamepad"
  }, [_c('span', {
    staticClass: "aboutTitle"
  }, [_vm._v("Coming Soon!")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  })])])
}]}

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('hello')], 1)
},staticRenderFns: []}

/***/ })
],[3]);


// WEBPACK FOOTER //
// static/js/app.ff2a0c9580937f217f7a.js